import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'

@Component
export default class TabItem extends Vue {
    @Prop({ type: Boolean, default: false }) disable!: boolean;    
    @Prop({ type: String }) header!: string
    @Prop({ type: String }) to!: string
    @Prop({ type: Number, default: 0 }) progress!: number
    @Prop({ type: Function }) onDisableClick!: () => void;

    onTabItemClick() {     
        if (!this.disable) {
            this.$router.push({ path: this.to })
        }
        else {
            if(this.onDisableClick) {
                this.onDisableClick();
            }            
        }
    }

    get isExactActive() {
        return (this.$route.path.includes(this.to))
    }  
}
